import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { Typography } from '@mui/material';
import Skeleton from '@mui/lab/Skeleton';

/**
 * Renders a select list controlled by Formik. Takes in a loading props to handle showing a skelton whilst waiting for data to load.
 *
 */
const SelectListGroup = ({ name, value, error, onChange, options, loading, label, isInline = false }) => {
    const selectOptions = options.map((option) => (
        <option key={option.label} value={option.value}>
            {option.label}
        </option>
    ));

    let wrapperClassName = ['form-group', 'row'];
    if (isInline) {
        wrapperClassName.push('form-check-inline');
    }

    return (
        <div className='form-group row' style={{ minWidth: 100 }}>
            {label && (
                <Typography className='col-3 col-form-label' variant='body2' style={{ fontFamily: 'Museo700' }}>
                    {label}
                </Typography>
            )}
            <div className='col'>
                {loading ? (
                    <Skeleton variant='rect' />
                ) : (
                    <Field
                        className={`form-control ${error ? 'is-invalid' : ''}`}
                        name={name}
                        value={value}
                        onChange={onChange}
                        as='select'
                    >
                        {selectOptions}
                    </Field>
                )}
            </div>
            {error && <div className='invalid-feedback'>{error}</div>}
        </div>
    );
};

SelectListGroup.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    isInline: PropTypes.bool,
};

export default SelectListGroup;
